import InvitationPage from './InvitationPage';
export default InvitationPage